import { useState } from "react";
import Input from "../../components/preview-input/input";
import useOrderStore from "../../store/order-store";
import { useLocation } from "react-router-dom";

function FastenerTypeSelection() {
  const { orderData,  setFormData } = useOrderStore();
  const selectedFastenerType = orderData.mountMethod;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const hasSheet = queryParams.get('hasSheet');
  const isDisabled =(hasSheet === 'true');
  const handleInputChange = (value) => {
    if(isDisabled){
      return
    }
    setFormData({ 
      ...orderData,
      mountMethod: value
     });
  };
  const handleInputChange2 = (field) => (e) => {
    setFormData({
      ...orderData,
      [field]: e.target.value
    });
  };
  return (
    <div className="k-display-flex k-mt-1">
      <h4 className="k-m-0 k-font-light k-pt-2 k-display-flex" style={{flexWrap:"wrap"}}>
        <label style={{ marginRight: "8px" }}>
          <input
          disabled={isDisabled}
            type="radio"
            name="fastenerType"
            value="Straps"
            checked={selectedFastenerType === "Straps"}
            onChange={() => handleInputChange("Straps")}
            style={{ marginRight: "10px",marginTop:"10px" }}
          />
          Straps
        </label>
        <label style={{marginRight:"10px"}}>
          <input
          disabled={isDisabled}
            type="radio"
            name="fastenerType"
            value="Rival Bar"
            checked={selectedFastenerType === "Rival Bar"}
            onChange={() => handleInputChange("Rival Bar")}
            style={{ marginRight: "10px",marginTop:"10px" }}
          />
          Rival Bar
        </label>
        <label style={{marginRight:"10px"}}>
          <input
          disabled={isDisabled}
            type="radio"
            name="fastenerType"
            value="Sickle & Shank"
            checked={selectedFastenerType === "Sickle & Shank"}
            onChange={() => handleInputChange("Sickle & Shank")}
            style={{ marginRight: "10px",marginTop:"10px" }}
          />
          Sickle & Shank
        </label>
        <label style={{marginRight:"10px"}}>
          <input
          disabled={isDisabled}
            type="radio"
            name="fastenerType"
            value="Fascia Hanger"
            checked={selectedFastenerType === "Fascia Hanger"}
            onChange={() => handleInputChange("Fascia Hanger")}
            style={{ marginRight: "10px",marginTop:"10px"}}
          />
          Fascia Hanger
        </label>
        <label style={{marginRight:"10px"}}>
          <input
          disabled={isDisabled}
            type="radio"
            name="fastenerType"
            value="T-Wedge"
            checked={selectedFastenerType === "T-Wedge"}
            onChange={() => handleInputChange("T-Wedge")}
            style={{ marginRight: "10px",marginTop:"10px" }}
          />
          T-Wedge
        </label>
      </h4>
      
      <div className="k-pos-relative k-top-1 k-ml-4 k-mt-3" style={{ width: "100px" }}>
        <Input type="number" value={orderData.mountingLength} onChange={handleInputChange2('mountingLength')}/>
      </div>

      <h4 className="k-m-0 k-font-light k-pt-2 k-ml-3 k-mt-3">
        FT.
      </h4>
    </div>
  );
}

export default FastenerTypeSelection;
